import React, { Component } from 'react'
import Button from '~/components/Button'
import SVG from '~/components/SVG'
import { unfollowUser, followUser } from '~/services'
import { universalDispatch } from '~/utils'
import identificationIcon from '~/assets/icon-identification.svg'
import plusIcon from '~/assets/icon-plus.svg'
import styles from './UserItem.css'

export default class UserItem extends Component {
  constructor(props) {
    super(props)
    this.state = {
      followed: props.followed === 1,
    }
  }

  handleClick = () => {
    const { followed } = this.state
    const { id } = this.props
    const updateFollowedStatus = followed ? unfollowUser : followUser

    universalDispatch(() => {
      updateFollowedStatus({ id }).then(() => {
        this.setState({ followed: !followed })
      })
    })
  }

  render() {
    const { followed } = this.state
    const { name, type, logo } = this.props

    return (
      <div className={styles.userItem}>
        <div className={styles.userItemLeft}>
          <img className={styles.userAvatar} src={logo} alt="" />
          <span className={styles.userName}>{name}</span>
          {type === 2 && (
            <SVG src={identificationIcon} width={16} height={16} />
          )}
        </div>
        {type === 2 ? (
          <div className={styles.userItemRight}>
            {followed ? (
              <Button onClick={this.handleClick} color="grey">
                已关注
              </Button>
            ) : (
              <Button
                className={styles.userFollowButton}
                onClick={this.handleClick}
              >
                <div>
                  <SVG src={plusIcon} width={12} height={12} />
                </div>
                <div>关注</div>
              </Button>
            )}
          </div>
        ) : null}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/Organizers/UserItem.js